import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateFlow = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateFlow&companyid=${user.companyid}&teststepid=${data.teststepid}&flow=${data.flow}&testcaseid=${data.tcid}`,
    {
      teststepid: data.teststepid,
      tcid: data.tcid,
      flow: data.flow
    }
  );

  return response.data;
};

const useUpdateFlowMutation = (options = {}) => {
  return useMutation({
    mutationFn: updateFlow,
    ...options,
  });
};

export default useUpdateFlowMutation; 